/*
 *   File : declaration-upload.js
 *   Author URI : https://evoqins.com
 *   Description : Upload declaration documents.
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal } from "bootstrap";
import { Tooltip } from 'react-tooltip';
import Cookies from 'js-cookie';
import parse from 'html-react-parser';

import { CustomFilePicker, FilePreview, RadioGroup } from "../../../../Component/Form-elements";
import { GradientButton, SecondaryButton } from "../../../../Component/CTA";
import { FatcaOTPVerification } from "../../../../Component/Modal";
import { Icon } from "../../../../Component/Icon";

import APIService from "../../../../Service/api-service";
import { _isFileTypeAllowed } from "../../../../Helper";
import { _uploadDocumentToS3 } from "../../../../Service/aws-service";
import Store from "../../../../Store";
import AadhaarEsignOtpModal from "../../../../Component/Modal/aadhaar-esign";

const KYC_TYPES = [
    {
        label: "Aadhaar e-Sign",
        id: 1
    },
    {
        label: "Manual form upload",
        id: 2
    }
]

export default function SubmitNRIKyc(props) {
    const formRef = useRef(null);
    const PROGRESS_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA);
    const GENERAL_DATA = useSelector(state => state.generalData.KYC_GENERAL_DATA);
    console.log('GENERAL_DATA', GENERAL_DATA);
    const reviewIsManual = PROGRESS_DATA?.nri_info?.is_manual ?? PROGRESS_DATA?.is_manual ?? false;
    const hasSelfieCapture = Boolean(PROGRESS_DATA?.selfie_captured);


    const [kycType, setKycType] = useState(null);
    const [kycTypes, setKycTypes] = useState(null);
    console.log('kycType', kycType);

    const [kycForm, setKycForm] = useState(null);
    const [kycFormError, setKycFormError] = useState("");

    const [foreignTax, setForeignTax] = useState(null);
    const [foreignTaxError, setForeignTaxError] = useState("");

    const [showPinModal, setShowPinModal] = useState(false);
    const [formData, setFormData] = useState(null);
    const [fileLoader, setFileLoader] = useState(false);
    const [apiLoader, setApiLoader] = useState(false);
    const [copyLinkLoader, setCopyLinkLoader] = useState(false);

    const [btnLoader, setBtnLoader] = useState(false);
    const [isManual, setIsManual] = useState(false);
    const [esign, setEsign] = useState(false);
    console.log('esign', esign);

    const IPV_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA.selfie_captured);
    const TOOL_TIP = useSelector(state => state.generalData.TOOL_TIP_DATA);

    const [selfieImage, setSelfieImage] = useState("");

    console.log('selfieImage', selfieImage);

    const [showEsignModal, setShowEsignModal] = useState(false);


    useEffect(() => {
        if (IPV_DATA !== null) {
            setSelfieImage(IPV_DATA);
        }
    }, [])

    useEffect(() => {
        if (GENERAL_DATA.kyc_submission_method) {
            const updated = GENERAL_DATA.kyc_submission_method.map(({ name, ...rest }) => ({
                label: name,
                ...rest
            }));

            setKycTypes(updated);
            setKycType((prev) => prev ?? updated[0].id)
        }
    }, [GENERAL_DATA.kyc_submission_method]);


    useEffect(() => {
        if (PROGRESS_DATA.is_review) {
            const isManualFlow = reviewIsManual;
            setIsManual(isManualFlow);
            if (GENERAL_DATA.kyc_submission_method?.length) {
                const matchedMethod = GENERAL_DATA.kyc_submission_method.find((item) => {
                    const methodName = (item.name || item.submission_type || "").toLowerCase();
                    return isManualFlow ? methodName.includes("manual") : methodName.includes("esign");
                });

                if (matchedMethod?.id) {
                    setKycType(matchedMethod.id);
                }
            }
        }
    }, [GENERAL_DATA.kyc_submission_method, PROGRESS_DATA.is_review, reviewIsManual]);

    useEffect(() => {
        if (props.back === true) {
            setIsManual(false);
        }
    }, [props.back])

    useEffect(() => {
        if (showEsignModal === true) {
            const modal = new Modal(document.getElementById("aadhaar-esign"));
            modal.show();
        }
    }, [showEsignModal]);



    const _handleProceed = (is_selfie_link) => {

        if (is_selfie_link === true) {
            setCopyLinkLoader(true);
        } else {
            setApiLoader(true);
        }

        let url = 'kyc/ipv/initiate';
        let payload = {
            is_selfie_link: is_selfie_link
        }
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                if (is_selfie_link === true) {
                    const selfieLink = response.data;
                    if (selfieLink) {
                        const t = document.createElement("textarea");
                        t.value = selfieLink;
                        document.body.appendChild(t);
                        t.select();
                        document.execCommand("copy");
                        document.body.removeChild(t);

                        toast.dismiss();
                        toast.success("Link copied!");

                    }
                } else {
                    _initiateDigiLocker(response.data.id, response.data.customer_identifier, response.data.access_token.id);
                    Cookies.set('digio_token', response.data.access_token.id);
                }
            } else {
                setApiLoader(false);
                setCopyLinkLoader(false);
                toast.dismiss();
                toast.error(response.message, {
                    type: "error"
                });
            }
        })
    };

    async function _initiateDigiLocker(digiLockerId, mail, token_id) {
        try {
            // Use sandbox/test URL
            const baseUrl = process.env.REACT_APP_DIGILOCKER_ENVIRONMENT === "production" ? "https://app.digio.in/#/gateway/login" : "https://ext-gateway.digio.in/#/gateway/login"

            const sdkver = "11.0";
            const method = "otp";
            const redirect_timeout = 2800;

            const theme = encodeURIComponent(
                JSON.stringify({
                    PRIMARY_COLOR: "#2979BF",
                    FONT_FAMILY: "",
                    FONT_URL: "",
                    FONT_FORMAT: "",
                })
            );

            const redirectUrl = encodeURIComponent(
                window.location.origin + "/digio-callback?verification-type=ipv"
            );

            const url = `${baseUrl}/${digiLockerId}/${token_id}/${mail}?token_id=${token_id}&sdkver=${sdkver}&method=${method}&redirect_timeout=${redirect_timeout}&theme=${theme}&redirect_url=${redirectUrl}`;


            console.log('redirectUrl', redirectUrl);

            // Open in a new tab / page
            window.location.href = (url);
        } catch (err) {
            console.error("Unable to open DigiLocker page", err);
        }

    };

    const _nextStep = async () => {
        setApiLoader(true);
        setApiLoader(false);
        props.updateProgress(10, "NRI");
    }

    useEffect(() => {
        if (showPinModal === true) {
            const modal = new Modal(document.getElementById("form-otp"));
            modal.show()
        }
    }, [showPinModal]);

    useEffect(() => {
        if (PROGRESS_DATA.bse_form_signed_url !== null) {
            const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.bse_form_signed_url));
            // Extract file name from URL
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setKycForm(fileName)
        }


        if (PROGRESS_DATA.ubo_form_signed_url !== null) {
            const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.ubo_form_signed_url));
            // Extract file name from URL
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setForeignTax(fileName)
        }

        setIsManual(reviewIsManual);
        setEsign(!reviewIsManual && hasSelfieCapture);


    }, [PROGRESS_DATA, hasSelfieCapture, reviewIsManual])

    function _handleInputFields(type, value, file) {
        // eslint-disable-next-line
        var file_formatted = value.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');

        switch (type) {
            case 1:
                if (parts.length > 1) {
                    const extension = '.' + parts.pop();
                    if (_isFileTypeAllowed(extension)) {
                        // checking if file size is greater than 5mb
                        const file_size = 5 * 1024 * 1024
                        if (file.size < file_size) {
                            _fileUpload(file_formatted, file, 1);
                        } else {
                            setKycFormError("File size should be less than 5mb");
                        }
                    }
                    else {
                        setKycFormError("File type should be .pdf, .jpeg, .jpg, .png");
                    }
                }
                break;
            case 4:
                if (parts.length > 1) {
                    const extension = '.' + parts.pop();
                    if (_isFileTypeAllowed(extension)) {
                        // checking if file size is greater than 5mb
                        const file_size = 5 * 1024 * 1024
                        if (file.size < file_size) {
                            _fileUpload(file_formatted, file, 4);
                        } else {
                            setForeignTaxError("File size should be less than 5mb");
                        }
                    }
                    else {
                        setForeignTaxError("File type should be .pdf, .jpeg, .jpg, .png");
                    }
                }
                break;

            default: break;
        }
    }


    function _resetErrors(type) {
        switch (type) {
            case 1:
                setKycFormError("");
                break;

            case 4:
                setForeignTaxError("");
                break;

            default:
                break;
        }
    }

    function _setFileUrls(type, url, key) {
        switch (type) {
            case 1:
                setKycForm(key);
                break;

            case 4:
                setForeignTax(key);
                break;

            default:
                break;
        }
    }

    //API :: file upload api
    const _fileUpload = (key, file, type) => {
        setFileLoader(type);
        _resetErrors(type)

        let url = "general/file-upload";
        let body = {
            "key": `support/${key}`
        }

        APIService(true, url, body).then((response) => {
            if (response.status_code === 200) {
                setFileLoader(type);

                // s3 helper
                _uploadDocumentToS3(response.data, key, file).then((result) => {
                    _uploadForm(type, response.data.view_info, key)
                }).catch(error => {
                    toast.dismiss();
                    toast.error(error, {
                        type: "error",
                    });
                    setFileLoader(false);
                });

            } else {
                setFileLoader(false);
                toast.dismiss();
                toast.error(response, {
                    type: "error",
                });
            }
        })
    }

    function _validateForm() {
        let valid = true;
        if (kycForm === null) {
            setKycFormError("Please upload file");
            formRef.current.scrollIntoView()
            valid = false
        }

        if (foreignTax === null) {
            setForeignTaxError("Please upload file");
            valid = false
        }

        if (valid === true) {
            _requestOtp()
        }
    }


    async function _submitOtp(otp) {
        setBtnLoader(true);
        let valid = false;
        let url = 'kyc/verify-2fa-form';
        let payload = {
            otp: otp,
            is_review: props.edit
        }
        await APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                setBtnLoader(false);
                Store.dispatch({
                    type: 'KYC_PROGRESS',
                    payload: response.kyc_data
                });
                valid = true
            } else {
                toast.dismiss();
                toast.error(response.message);
                setBtnLoader(false);
                valid = false
            }
        })
        return valid
    }

    const _requestOtp = (is_resend = false) => {
        if (is_resend === false) {
            setApiLoader(true);
        }
        let url = 'kyc/request-2fa-form';

        APIService(false, url).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                setShowPinModal(true);
                if (is_resend) {
                    toast.success('OTP has been re-sent to your registered email and phone number', {
                        type: "success"
                    });
                } else {
                    toast.success('OTP has been sent to your registered email and phone number', {
                        type: "success"
                    });
                }
            } else {
                toast.dismiss();
                toast.error(response.message)
            }
            setApiLoader(false);
        })
    }

    const _getForms = (type) => {
        setFormData(type);
        let url = 'kyc/digilocker/create-form-nri';
        let payload = {
            file_type: type
        }
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                window.open(response.data, "_blank");
            } else {
                toast.dismiss();
                toast.error(response.message)
            }
            setFormData(null);
        })
    }

    const _uploadForm = (type, url, key) => {
        let api_url = 'kyc/digilocker/upload-form';
        let payload = {
            file_type: type,
            url: url
        }
        APIService(true, api_url, payload).then((response) => {
            if (response.status_code === 200) {
                _setFileUrls(type, url, key);
                setFileLoader(false);
            } else {
                toast.dismiss();
                toast.error(response.message)
            }
        })
    }
    const _handleKycSubmission = () => {
        setApiLoader(true);
        let api_url = 'kyc/kyc-submission-method';
        let payload = {
            "method_id": kycType
        }
        APIService(true, api_url, payload).then((response) => {
            if (response.status_code === 200) {
                props.submitKycType(true)
                PROGRESS_DATA.is_manual = kycType === 253 ? false : true;
                Store.dispatch({
                    type: 'KYC_PROGRESS',
                    payload: PROGRESS_DATA
                });

                if (kycType === 253) {
                    setShowEsignModal(true);
                } else {
                    setIsManual(true);
                    setEsign(false);
                }

            } else {
                toast.dismiss();
                toast.error(response.message)
            }
            setApiLoader(false);
        })
    }


    return (
        <>
            {
                (!isManual && !esign) ?
                    <div className="row">
                        <div className="col-12" >
                            <h2 className="color-black e-inter-bold e-font-24 mb-2">
                                Choose how to submit your KYC
                            </h2>
                            <p className="color-outer-space e-poppins-regular e-font-16 mb-0">
                                Pick one of the following submission methods
                            </p>

                            {kycTypes !== null &&
                                <RadioGroup data={kycTypes}
                                    className={`gap-16px margin-40px-top`}
                                    type={1}
                                    id={kycType}
                                    radioItem="w-max-content"
                                    iconClassName="me-2"
                                    radioHandler={(id) => setKycType(id)} />
                            }

                            <div className="col-lg-9">
                                <div className="d-flex align-items-start gap-8px bg-mint-cream p-2  border-radius-8px margin-32px-top">
                                    <div className="w-max-content">
                                        <Icon icon="info"
                                            size={24} />
                                    </div>
                                    <p className="e-font-14 e-poppins-regular line-height-24px color-jett-black mb-0">
                                        {kycType === 2 ? "You will be required to download the KYC form, sign it, and upload a scanned copy of the signed form."
                                            : "You must have an Aadhaar card and access to the mobile number linked with your Aadhaar for OTP-based authentication. If you do not have access to that number, please choose the ‘Manual Form Download’ option."}
                                    </p>
                                </div>
                            </div>
                            <GradientButton label={kycType === 253 ? "Proceed Aadhar e-sign" : "Manually verify KYC"}
                                className="px-3 padding-12px-tb e-font-16 margin-40px-top"
                                loading={apiLoader}
                                handleClick={() => {
                                    _handleKycSubmission();
                                }} />
                        </div>
                    </div>
                    :
                    esign === true ?
                        selfieImage.length !== 0
                            ?
                            <div className='pb-sm-0 pb-4'>
                                <p className='color-black e-poppins-bold e-font-24-sm-18 mb-2'>Capture your selfie</p>
                                <p className='color-outer-space e-poppins-regular line-height-24px margin-32px-bottom e-font-sm-16-14  '>Your selfie has been successfully captured.</p>
                                <img src={selfieImage} alt="Selfie"
                                    width={226}
                                    draggable={false}
                                    height={208}
                                    className='object-fit-contain mb-4' />
                                <div className='d-flex align-items-center gap-8px margin-40px-bottom cursor-pointer w-max-content'
                                    onClick={() => _handleProceed(false)}>
                                    <Icon icon="re-capture"
                                        size={24} />
                                    <p className='color-primary-color e-poppins-regular e-font-sm-16-14 line-height-24px mb-0'>Re-capture</p>
                                </div>
                                <div className="d-flex align-items-center gap-3">
                                    <GradientButton label="Save & proceed"
                                        loading={apiLoader}
                                        className="margin-40px-top padding-12px-tb px-4"
                                        handleClick={_nextStep} />
                                    <SecondaryButton label="Copy link"
                                        handleClick={() => _handleProceed(true)}
                                        loading={copyLinkLoader}
                                        className="margin-40px-top padding-12px-tb color-primary-color e-font-16" />
                                </div>

                            </div>
                            :
                            <div className="row pb-sm-0 pb-4">
                                <div className="col-sm-7 pe-5 order-sm-1 order-2 mt-sm-0 mt-3 mb-sm-0 mb-3">
                                    <p className="color-black e-poppins e-poppins-bold e-font-24-sm-18 mb-2 position-relative w-max-content">
                                        Capture your selfie
                                        {
                                            Object.keys(TOOL_TIP).length !== 0 && (
                                                <>
                                                    <Icon icon="info"
                                                        size={24}
                                                        className="ms-2"
                                                        data-tooltip-id="ipv-tooltip" />
                                                    <Tooltip id="ipv-tooltip"
                                                        arrowColor='transparent'
                                                        effect="float"
                                                        place="bottom"
                                                        className='e-tooltip-general'>
                                                        {parse(TOOL_TIP.kyc_ipv_step)}
                                                    </Tooltip>
                                                </>
                                            )
                                        }

                                    </p>
                                    <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-24px mb-0 pe-5">
                                        For clear selfie, follow the below instructions.
                                    </p>

                                    {/* <p className="color-black e-poppins-bold e-font-16 line-height-24px mb-0 px-4 py-3 margin-40px-bottom w-fit-content e-dashed-otp mt-3">
                                2406
                            </p> */}

                                    <div className="border-radius-16px bg-beige p-3 margin-40px-top pe-4">
                                        <p className="color-black e-poppins-medium e-font-14-sm-12 line-height-14px mb-2">*Note</p>
                                        <ol className="ps-3">
                                            <li className="color-outer-space e-poppins-regular e-font-14-sm-12 line-height-20px mb-0">
                                                Make sure the place where you are taking a selfie is well lit and not dark.
                                            </li>
                                            <li className="color-outer-space e-poppins-regular e-font-14-sm-12 line-height-20px mb-0">
                                                Do not wear eyeglasses.
                                            </li>
                                            <li className="color-outer-space e-poppins-regular e-font-14-sm-12 line-height-20px mb-0">
                                                Ensure your face is within the frame.
                                            </li>
                                            <li className="color-outer-space e-poppins-regular e-font-14-sm-12 line-height-20px mb-0">
                                                Position your face in the frame and move your head in a circle.
                                            </li>
                                        </ol>

                                    </div>
                                    <div className="d-flex align-items-center gap-3 margin-40px-top">
                                        <GradientButton label="Proceed"
                                            className=" padding-12px-tb px-4 e-font-16"
                                            loading={apiLoader}
                                            handleClick={() => _handleProceed(false)} />
                                        <SecondaryButton label="Copy link"
                                            handleClick={() => _handleProceed(true)}
                                            loading={copyLinkLoader}
                                            className=" padding-12px-tb color-primary-color e-font-16" />
                                    </div>

                                </div>
                                <div className="col-sm-5 order-sm-2 order-1">
                                    {/* <p className="color-black e-poppins-bold e-font-16 mb-3">Example</p> */}
                                    <img src={require("../../../../Assets/Images/kyc/ipv.png")}
                                        alt="IPV"
                                        draggable={false}
                                        height={312}
                                        className="object-fit-contain" />
                                </div>

                            </div>
                        :
                        <div className="row" ref={formRef}>
                            <div className="col-12" >
                                <h2 className="color-black e-inter-bold e-font-24 mb-2">
                                    AOF & FATCA/UBO declaration
                                </h2>
                                <p className="color-outer-space e-poppins-regular e-font-16 mb-4">
                                    To complete the investment process, submission of the Account Opening Form (AOF), Foreign Account Tax Compliance Act (FATCA) declaration, and Ultimate Beneficial Ownership (UBO) details is required.
                                </p>

                                {/* Karta */}
                                <div className="row pt-3" >
                                    <span className="color-jett-black e-poppins-semi-bold e-font-16 line-height-24px mb-3">1. KYC form download</span>
                                    <div className="col-lg-5 col-sm-6">
                                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">1. Download the form</p>
                                        <div className="border-columbia-blue border-all border-radius-16px padding-12px-tb px-3 d-flex align-items-center justify-content-between mt-3 cursor-pointer"
                                            onClick={() => _getForms(1)}>
                                            <div className="d-flex color-dim-gray gap-2 align-items-center e-inter-regular e-font-14">
                                                <img src={require("../../../../Assets/Images/kyc/pdf.png")}
                                                    alt="pdf"
                                                    width={40}
                                                    height={40} />
                                                Account Opening form
                                            </div>
                                            {formData === 1 ?
                                                <img src={require('../../../../Assets/Images/loader.gif')}
                                                    width={40}
                                                    height={40} />
                                                :
                                                <img src={require("../../../../Assets/Images/kyc/download.png")}
                                                    alt="pdf"
                                                />}
                                        </div>
                                        <div className="d-flex gap-2 color-primary-color e-font-12 e-poppins-regular mt-2 align-items-center">

                                            <img src={require('../../../../Assets/Images/kyc/info-circle.svg').default}
                                                alt="Info" />
                                            *We required forms with stamp & signature.
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-sm-6 pt-lg-0 pt-4">
                                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">2. Upload the form</p>
                                        <p className="color-black e-font-14 e-poppins-regular mb-1"> Upload AOF form</p>
                                        {
                                            kycForm === null ?

                                                <CustomFilePicker accept=".png, .pdf, .jpeg "
                                                    className="e-select-file"
                                                    error={kycFormError}
                                                    loading={fileLoader === 1}
                                                    onSelectFile={(value, file) => _handleInputFields(1, value, file)} />
                                                :
                                                <FilePreview fileName={kycForm}
                                                    removeFile={() => {
                                                        setKycForm(null);
                                                        setKycFormError("");
                                                    }} />
                                        }

                                    </div>
                                    <div className="col-lg-3 pt-lg-4 mt-lg-4">
                                        {kycForm !== null && <span className="color-ufo-green e-poppins-regular e-font-14  pt-3">Successfully uploaded the form</span>}
                                    </div>
                                </div>

                                {/*foreign tax */}
                                <div className="row pt-3">
                                    <span className="color-jett-black e-poppins-semi-bold e-font-16 line-height-24px mt-4 mb-3">2. Foreign Account Tax Compliance Act / Ultimate Beneficial Ownership</span>
                                    <div className="col-lg-5 col-sm-6">
                                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">1. Download the form</p>
                                        <div className="border-columbia-blue border-all border-radius-16px padding-12px-tb px-3 d-flex align-items-center justify-content-between mt-3 cursor-pointer"
                                            onClick={() => _getForms(4)}>
                                            <div className="d-flex color-dim-gray gap-2 align-items-center e-inter-regular e-font-14">
                                                <img src={require("../../../../Assets/Images/kyc/pdf.png")}
                                                    alt="pdf"
                                                    width={40}
                                                    height={40} />
                                                Foreign Account Tax Compliance Act
                                            </div>
                                            {formData === 4 ?
                                                <img src={require('../../../../Assets/Images/loader.gif')}
                                                    width={40}
                                                    height={40} />
                                                :
                                                <img src={require("../../../../Assets/Images/kyc/download.png")}
                                                    alt="pdf"
                                                />}
                                        </div>
                                        <div className="d-flex gap-2 color-primary-color e-font-12 e-poppins-regular mt-2 align-items-center">

                                            <img src={require('../../../../Assets/Images/kyc/info-circle.svg').default}
                                                alt="Info" />
                                            *We required forms with stamp & signature.
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-sm-6 pt-lg-0 pt-4">
                                        <p className="color-outer-space e-font-12 e-poppins-regular mb-0">2. Upload the form</p>
                                        <p className="color-black e-font-14 e-poppins-regular mb-1">Upload FATCA/UBO</p>
                                        {
                                            foreignTax === null ?

                                                <CustomFilePicker accept=".png, .pdf, .jpeg "
                                                    className="e-select-file"
                                                    error={foreignTaxError}
                                                    loading={fileLoader === 2}
                                                    onSelectFile={(value, file) => _handleInputFields(4, value, file)} />
                                                :
                                                <FilePreview fileName={foreignTax}
                                                    removeFile={() => {
                                                        setForeignTax(null);
                                                        setForeignTaxError("");
                                                    }} />
                                        }

                                    </div>
                                    <div className="col-lg-3 pt-lg-4 mt-lg-4">
                                        {
                                            foreignTax !== null && <span className="color-ufo-green e-poppins-regular e-font-14  pt-3">Successfully uploaded the form</span>
                                        }
                                    </div>
                                </div>


                                <GradientButton label="Submit"
                                    className="px-3 padding-12px-tb e-font-16 margin-40px-top"
                                    loading={apiLoader}
                                    handleClick={_validateForm} />
                            </div>
                            {
                                showPinModal === true && (
                                    <FatcaOTPVerification close={() => setShowPinModal(false)}
                                        handleOTPSubmission={_submitOtp}
                                        loader={btnLoader}
                                        resendOtp={_requestOtp}
                                        handleSuccess={() => props.updateProgress(PROGRESS_DATA.is_review ? 10 : 7, props.text, props.is_manual)}
                                    />
                                )
                            }
                        </div>
            }
            {
                showEsignModal === true && <AadhaarEsignOtpModal close={() => setShowEsignModal(false)}
                    handleProceed={() => {
                        setEsign(true);
                        setIsManual(true);
                        setShowEsignModal(false);
                    }} />
            }
        </>

    )
}
